import * as ts from "../common/Translator";
import NaMaAboutDialogTemplate from "../compiled-templates/NaMaAboutDialogTemplate";
import {appVersion, getBuildDate, getLatestRelease} from "../common/DefaultApplicationInfo";
import {getCustomerSupportEndDate, getLicenceDetails} from "../common/NamaCommon";
import {NamaKendoWindow, NamaWindowBtnData} from "./NamaKendoWindow";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import * as metadata from "../common/Metadata";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import {createTroubleTicketActionHandler} from "../routing/EditPresenter";
import ExceedAboutDialogTemplate from "../compiled-templates/ExceedAboutDialogTemplate";
import CapitalAboutDialogTemplate from "../compiled-templates/CapitalAboutDialogTemplate";

let documentBookMetaData;

export class NaMaAboutDialog {
    constructor() {
        let that = this;
        let tmplt = NaMaAboutDialogTemplate;
        if (window.branding === 'exceed')
            tmplt = ExceedAboutDialogTemplate;
        else if (window.branding === 'capital')
            tmplt = CapitalAboutDialogTemplate;
        that.dialogContent = $(tmplt({
            applicationVersion: appVersion(),
            dbBuildDate: getBuildDate(),
            latestRelease: getLatestRelease(),
            customerSupportEndDate: getCustomerSupportEndDate(),
            licenceDetails: getLicenceDetails(),
            translateId: ts.translateId,
        }));
        that.dialog = new NamaKendoWindow("about", new NamaWindowBtnData("ok", () => that.dialog.closeWindow()), new NamaWindowBtnData("cancel"), "60%", true);
        that.dialog.addDataWidget(that.dialogContent);
        that.dialog.content.css("overflow", "hidden");
        that.dialogContent.find("#close").kendoButton({
            click: e => {
                that.dialog.closeWindow();
            }
        });
        that.dialogContent.find("#createCRMTroubleTicket").kendoButton({
            click: e => {
                that.dialog.closeWindow();
                that.createCRMTroubleTicket();
            }
        });

    }

    createCRMTroubleTicket() {
        if (!documentBookMetaData) {
            let req = {owner: {ownerType: OwnerType.Entity, ownerId: DomainBaseEntities.DocumentBook}};
            req.properties = [PreferencesRequest.META_DATA];

            metadata.fetchPreferences(req, (value) => {
                documentBookMetaData = value.metaData;
                this.createCRMTroubleTicket();
            });
        } else {
            createTroubleTicketActionHandler(documentBookMetaData, "", []);
        }
    }

    show() {
        this.dialog.showWindow();
    }
}
